window.Sales = require('./react_components/sales')
window.SalesHistory = require('./react_components/sales_history')
window.Payments = require('./react_components/payments')
window.NewsAndForums = require('./react_components/news_and_forums')
window.Publishing = require('./react_components/publishing')
window.CheckMate = require('./react_components/checkmate')
window.CheckMateQueue = require('./react_components/checkmate_queue')
window.StemcellQueue = require('./react_components/stemcell_queue')
window.EnhancedDatadealProgress = require('./react_components/enhanced_datadeal_progress')
